<template>
  <div>
    <Subheader title="About us" :has-accent-color="true" />

    <div class="app-content-column">
      <div class="card">
        <h5>Mzingo Partners Welcomes You</h5>
        <p>
          At Mzingo, your satisfaction is our main priority - dedication to success our driving
          focus. By working flexibly within the industry specific context of doing business in
          Kenya, our partnership approach fosters confidence in our clients that their investment
          will yield solid returns and long lasting solutions for mutual success.
        </p>
        <img src="@/assets/images/about1.jpg" alt="meeting" />

        <div class="row">
          <div class="left">
            <h5>Learn About Our Business</h5>
            <p>
              Since beginning operations in 2019, Mzingo Partners has been fully dedicated to client
              satisfaction. In all that we do, we strive to work with integrity in order to provide
              high-quality results. Please get in touch with us today, we would love to speak with
              about any of your organizational’ needs.
            </p>
            <router-link :to="{ name: 'Contacts' }">
              Contact us
            </router-link>

            <h5>Services Available</h5>
            <p>
              Resulting from our dedication to being fully flexible, clients can consistently expect
              an openness to new ideas, necessary changes, ethically rigidity when necessary being
              firm at firm at firm at moments when experience knows a road is heading on a collision
              Our personalized services and wide range of price accommodations cater to every you’re
              you’re sure to find the solutions you need. Take a look below at all of the services
              that we offer and get in touch for more details today. Let us accommodate your
              institutional context:<br />
              Programs & Operations - NGO Support - Community Engagement - Finance & Administration
              Partnerships for Success
            </p>
          </div>
          <div class="right">
            <img src="@/assets/images/about2.jpeg" alt="changefunder man" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'

export default {
  name: 'About',
  components: {
    Subheader,
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/cards';
@import '../styles/layout';

.card {
  @include card-w-borders();

  box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  border: none;
}

.row {
  display: flex;

  @media screen and (max-width: 900px) {
    flex-direction: column;
  }

  h5 {
    margin-top: 32px;
  }

  .left {
    flex: 3;

    @media screen and (min-width: 901px) {
      padding-right: 24px;
    }
  }

  .right {
    display: flex;
    align-items: center;
    flex: 2;
  }
}

img {
  width: 100%;
}
</style>
